module.exports = __webpack_public_path__ + "static/media/future.2e658636.png";